import { NgModule } from "@angular/core";

import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { OverlayPanelModule } from "@bfx/primeng/overlaypanel";
import { ButtonModule } from "@bfx/primeng/button";
import { TabViewModule } from "@bfx/primeng/tabview";
import { TieredMenuModule } from "@bfx/primeng/tieredmenu";
import { SplitterModule } from "@bfx/primeng/splitter";

// services
import { BmarkFixingsManagerService } from "./services/bmark-fixings-manager.service";
// components
import { BmarkSummaryContainerComponent } from "./bmark-summary-container.component";
import { BmarkSummaryFixingsComponent } from "./bmark-summary-fixings.component";
import { BmarkSummaryClientOrdersComponent } from "./bmark-summary-client-orders.component";
import { BmarkSummarySpotRiskContainerComponent } from "./bmark-summary-spot-risk.component";
import { BmarkSummaryHedgeOrdersComponent } from "./bmark-summary-hedge-orders.component";
import { BmarkSummarySettingsMenuComponent } from "./bmark-summary-settings-menu.component";

//
import { BfxMenusModule } from "../bfx-menus/bfx-menus.module";

import { PerfectScrollbarModule } from "@bfx/ngx-perfect-scrollbar";
import { BfxElementsLibraryModule } from "../bfx-element-library/bfx-elements-library.module";
//import { BfxBmarkClientOrdersBlotterModule } from './blotters/client-orders/bfx-bmark-client-orders-blotter.module';
import { BmarkBlotterBaseFilteringService } from "./services/bmark-blotter-base-filtering.service";
import { BmarkBlotterViewFilterSelectionService } from "./services/bmark-blotter-view-filter-selection.service";
import { BmarkClientOrdersBlotterComponent } from "./blotters/client-orders/bmark-client-orders-blotter.component";
import { BmarkClientOrdersContextMenuComponent } from "./blotters/client-orders/bmark-client-orders-context-menu.component";
import { BmarkClientOrdersDataService } from "./blotters/client-orders/services/bmark-client-orders-data.service";
import { BfxBmarkClientOrdersBlotterActionsService } from "./blotters/client-orders/services/bmark-client-orders-actions.service";
import { BmarkClientOrdersContextMenuService } from "./blotters/client-orders/services/bmark-client-orders-context-menu.service";
import { BmarkClientOrdersFilterService } from "./blotters/client-orders/services/bmark-client-orders-filter.service";
import { BmarkHedgeOrdersBlotterComponent } from "./blotters/hedge-orders/bmark-hedge-orders-blotter.component";
import { BmarkHedgeOrdersContextMenuComponent } from "./blotters/hedge-orders/bmark-hedge-orders-context-menu.component";
import { BfxBmarkHedgeOrdersBlotterActionsService } from "./blotters/hedge-orders/services/bmark-hedge-orders-actions.service";
import { AutoHedgeRenderer } from "./blotters/hedge-orders/renderers/AutoHedgeRenderer";
import { BmarkHedgeOrdersContextMenuService } from "./blotters/hedge-orders/services/bmark-hedge-orders-context-menu.service";
import { BmarkHedgeOrdersFilterService } from "./blotters/hedge-orders/services/bmark-hedge-orders-filter.service";
import { BfxBaseBlotterColumnSelectorService } from "../bfx-base-blotter/bfx-base-blotter-columnselector.service";
import { BmarkSummaryUtilService } from "./services/bmark-summary-util.service";
import { AgGridModule } from "@bfx/ag-grid-angular";
import { BfxBlotterFilterModule } from "../bfx-blotter-filter/bfx-blotter-filter.module";
import { BfxBlotterOrdersActionSubjectModule } from "../bfx-blotter-orders/bfx-blotter-orders-action-subject.module";
import { NativeDesktopModule } from "../bfx-native-desktop/native-desktop-support.module";

// risk view
import { BmarkSpotRiskBlotterComponent } from "./blotters/spot-risk/bmark-spot-risk-blotter.component";
import { BmarkSpotRiskDataService } from "./blotters/spot-risk/services/bmark-spot-risk-data.service";
import { BmarkSpotRiskFilteringService } from "./blotters/spot-risk/services/bmark-spot-risk-filtering.service";
import { BmarkSpotRiskContextMenuComponent } from "./blotters/spot-risk/bmark-spot-risk-context-menu.component";
import { BmarkSpotRiskInstrumentRendererComponent } from "./blotters/spot-risk/renderers/bmark-spot-risk-instrument-renderer.component";
import { BmarkSpotRiskTotalsRendererComponent } from "./blotters/spot-risk/renderers/bmark-spot-risk-totals-renderer.component";
import { BmarkSpotRiskTraderGroupRendererComponent } from "./blotters/spot-risk/renderers/bmark-spot-risk-trader-group-renderer.component";
import { BmarkSpotRiskContextMenuService } from "./blotters/spot-risk/services/bmark-spot-risk-context-menu.service";
import { BmarkSpotRiskTraderGroupsMenuComponent } from "./blotters/spot-risk/bmark-spot-risk-tradergroups-menu.component";
import { BfxVwapModule } from "../bfx-vwap/bfx-vwap.module";
import { BfxInterfaceControlsModule } from "../bfx-interface-controls/bfx-interface-controls.module";
import { BfxSharedModule } from "../bfx-shared/bfx-shared.module";
import { TgStatusColumnHeaderComponent } from "./blotters/spot-risk/TgStatusColumnHeaderComponent";
import { BfxFixingBlotterAuditComponent } from "app/bfx-bmark-summary/blotters/fixing-audit/bfx-fixing-blotter-audit.component";
import { BmarkSummaryActionSubjectModule } from "./bmark-summary-action-subject.module";
import { BaseComponentsModule } from "shared/base-components/base-components.module";
import { DialogService } from "@bfx/primeng/dynamicdialog";
import { DataTableModule } from "@bfx/primeng/datatable";
import { BfxBlotterCommonModule } from "app/bfx-blotter-common/bfx-blotter-common.module";
import { BmarkHedgeOrdersDataService } from "app/bfx-bmark-summary/blotters/hedge-orders/services/bmark-hedge-orders-data.service";
import { BmarkHOMOrdersBlotterComponent } from "app/bfx-bmark-summary/blotters/hedge-orders/bmark-hom-orders-blotter.component";
import { BfxFixingDatePipe } from "app/bfx-bmark-summary/pipes/fixing-date.pipe";
import { BfxFixingTimePipe } from "app/bfx-bmark-summary/pipes/fixing-time.pipe";
import { BmarkSummaryFwdRiskContainerComponent } from "app/bfx-bmark-summary/bmark-summary-fwd-risk.component";
import { BmarkFwdRiskBlotterComponent } from "app/bfx-bmark-summary/blotters/spot-risk/bmark-fwd-risk-blotter.component";
import { BmarkFwdRiskDataService } from "app/bfx-bmark-summary/blotters/spot-risk/services/bmark-fwd-risk-data.service";
import { BmarkFwdRiskInstrumentRendererComponent } from "app/bfx-bmark-summary/blotters/spot-risk/renderers/bmark-fwd-risk-instrument-renderer.component";
import { BmarkFwdRiskContextMenuService } from "app/bfx-bmark-summary/blotters/spot-risk/services/bmark-fwd-risk-context-menu.service";
import { BmarkFwdRiskContextMenuComponent } from "app/bfx-bmark-summary/blotters/spot-risk/bmark-fwd-risk-context-menu.component";
import { SplitButtonModule } from "@bfx/primeng/splitbutton";
import { BfxBlotterRiskFilterComponent } from "app/bfx-bmark-summary/bfx-risk-filter.component";
import { BmarkFwdRiskTotalsRendererComponent } from "app/bfx-bmark-summary/blotters/spot-risk/renderers/bmark-fwd-risk-totals-renderer.component";
import { BmarkFwdRiskTraderGroupRendererComponent } from "app/bfx-bmark-summary/blotters/spot-risk/renderers/bmark-fwd-risk-trader-group-renderer.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    PerfectScrollbarModule,
    OverlayPanelModule,
    ButtonModule,
    TabViewModule,
    SplitterModule,
    AgGridModule.withComponents([]),
    BfxBlotterFilterModule,
    BfxMenusModule,
    TieredMenuModule,
    BfxVwapModule,
    BfxElementsLibraryModule,
    BfxBlotterOrdersActionSubjectModule,
    NativeDesktopModule,
    BfxSharedModule,
    BfxInterfaceControlsModule,
    BmarkSummaryActionSubjectModule,
    BaseComponentsModule,
    BfxBlotterCommonModule,
    DataTableModule,
    SplitButtonModule,
  ],
  declarations: [
    BmarkSummaryFixingsComponent,
    BmarkSummaryContainerComponent,
    BmarkSummaryClientOrdersComponent,
    BmarkSummarySpotRiskContainerComponent,
    BmarkSummaryHedgeOrdersComponent,
    BmarkSummarySettingsMenuComponent,
    BmarkClientOrdersBlotterComponent,
    BmarkClientOrdersContextMenuComponent,
    BmarkHedgeOrdersBlotterComponent,
    BmarkHOMOrdersBlotterComponent,
    BmarkHedgeOrdersContextMenuComponent,
    BmarkSpotRiskBlotterComponent,
    BmarkSpotRiskContextMenuComponent,
    BmarkFwdRiskContextMenuComponent,
    BmarkSpotRiskTraderGroupsMenuComponent,
    BmarkSpotRiskInstrumentRendererComponent,
    BmarkFwdRiskInstrumentRendererComponent,
    BmarkSpotRiskTotalsRendererComponent,
    BmarkFwdRiskTotalsRendererComponent,
    BmarkSpotRiskTraderGroupRendererComponent,
    BmarkFwdRiskTraderGroupRendererComponent,
    TgStatusColumnHeaderComponent,
    BfxFixingBlotterAuditComponent,
    AutoHedgeRenderer,
    BfxFixingDatePipe,
    BfxFixingTimePipe,

    BmarkSummaryFwdRiskContainerComponent,
    BmarkFwdRiskBlotterComponent,
    BfxBlotterRiskFilterComponent,
  ],
  providers: [
    BmarkFixingsManagerService,
    BmarkClientOrdersDataService,
    BmarkHedgeOrdersDataService,
    BfxBmarkClientOrdersBlotterActionsService,
    BmarkClientOrdersContextMenuService,
    BmarkClientOrdersFilterService,
    BmarkBlotterBaseFilteringService,
    BmarkSpotRiskFilteringService,
    BfxBaseBlotterColumnSelectorService,
    BfxBmarkHedgeOrdersBlotterActionsService,
    BmarkHedgeOrdersContextMenuService,
    BmarkHedgeOrdersFilterService,
    BmarkBlotterViewFilterSelectionService,
    BfxBaseBlotterColumnSelectorService,
    BmarkSummaryUtilService,
    BmarkSpotRiskDataService,
    BmarkSpotRiskContextMenuService,
    BmarkFwdRiskContextMenuService,
    DialogService,
    BmarkFwdRiskDataService,
  ],
  exports: [
    BmarkSummaryContainerComponent,
    BmarkHedgeOrdersBlotterComponent,
    BmarkHOMOrdersBlotterComponent,
    BmarkSpotRiskInstrumentRendererComponent,
    BmarkFwdRiskInstrumentRendererComponent,
    BmarkSpotRiskTotalsRendererComponent,
    BmarkFwdRiskTotalsRendererComponent,
    BmarkSpotRiskTraderGroupRendererComponent,
    BmarkFwdRiskTraderGroupRendererComponent,
  ],
  bootstrap: [BmarkSummaryContainerComponent],
})
export class BmarkSummaryModule {}
